import React, { Component } from "react";
import "../Form/proposalForm.css";

class TableHeader extends Component {
  componentDidMount = () => {
    let columnsList = [];
    this.props.columns.forEach((element) => {
      if (typeof element.label === "string" && element.path !== undefined)
        columnsList.push(element);
    });
    this.props.updateColumnList(columnsList);
  };

  raiseSort = (path) => {
    const sortColumn = { ...this.props.sortColumn };
    if (sortColumn.path === path)
      sortColumn.order = sortColumn.order === "asc" ? "desc" : "asc";
    else {
      sortColumn.path = path;
      sortColumn.order = "asc";
    }
    if (sortColumn.path !== undefined) {
      this.props.onSort(sortColumn);
    }
  };

  renderSortIcon = (column) => {
    const { sortColumn } = this.props;
    if (column.path !== sortColumn.path || sortColumn.path === undefined)
      return null;
    if (sortColumn.order === "asc")
      return <span style={{ margin: "auto", fontSize: "10px" }}>&#9650;</span>;
    return <span style={{ margin: "auto", fontSize: "10px" }}>&#9660;</span>;
  };

  renderCell = (column) => {
    if (typeof column.label !== "string") return column.label(column);
    return column.label;
  };

  render() {
    return (
      <thead>
        <tr className="vicus-blue">
          {this.props.columns &&
            this.props.columns.map((column) => (
              <th
                className={column.path !== undefined ? "clickable" : ""}
                key={column.path || column.key}
                onClick={
                  column.path !== undefined
                    ? () => this.raiseSort(column.path)
                    : undefined
                }
                style={{
                  width: typeof column.label === "string" ? "7vw" : "1vw",
                  cursor: column.path !== undefined ? "pointer" : "default",
                  ...(column.headerStyle || {}),
                }}
              >
                {this.renderCell(column)} {this.renderSortIcon(column)}
              </th>
            ))}
        </tr>
      </thead>
    );
  }
}

export default TableHeader;
